/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./risB.vue?vue&type=template&id=0a818381&scoped=true"
import script from "./risB.vue?vue&type=script&lang=js"
export * from "./risB.vue?vue&type=script&lang=js"
import style0 from "./risB.vue?vue&type=style&index=0&id=0a818381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a818381",
  null
  
)

export default component.exports